import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { Coupon } from './Coupon'
import { Id } from '@/infra/id'

export type UserCouponProps = ModelProps<UserCoupon>

/**
 * A coupon added to a user.
 */
export class UserCoupon extends Model<UserCoupon> {
  id = Id.none

  @observable accessor userId = Id.none
  @observable accessor workspaceId = Id.none
  @observable accessor redeemed = false
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateRedeemed = unixEpoch()
  @observable accessor coupon = Coupon.none
}
